var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardDiscover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.39 14.92s2.48.3 2.48-2-2.48-2-2.48-2zm-1.19-4.92h2a3 3 0 0 1 0 5.95h-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7.75 10h-1.2v6h1.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11.51 11.35a1.33 1.33 0 0 0 -.89-.5.78.78 0 0 0 -.79.6c0 .29 0 .39.79.69s1.89.5 1.89 1.88a2 2 0 0 1 -2 2 2.64 2.64 0 0 1 -2.18-1.09l.79-.8a1.74 1.74 0 0 0 1.29.8.8.8 0 0 0 .9-.8c0-.29-.2-.59-.7-.79s-1.88-.4-1.88-1.69a1.74 1.74 0 0 1 1.88-1.78 3 3 0 0 1 1.69.69z",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m17.27 11.64a2.15 2.15 0 0 0 -1.49-.64 2.09 2.09 0 0 0 0 4.17 2.12 2.12 0 0 0 1.49-.7v1.39a3.31 3.31 0 0 1 -1.49.4 3.18 3.18 0 0 1 0-6.35 2.79 2.79 0 0 1 1.49.4z",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m23.81 10h1.29l1.69 4 1.59-4h1.29l-2.58 6.15h-.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m35.32 11v1.79h.68a.86.86 0 0 0 .8-.8v-.1a.79.79 0 0 0 -.8-.79h-.69zm-1.09-1h2a1.76 1.76 0 0 1 1.89 1.78 1.72 1.72 0 0 1 -1.29 1.69l1.78 2.48h-1.5l-1.59-2.38h-.1v2.38h-1.19z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m33.34 12.34v1.09h-2.09v1.49h2.18v1.08h-3.37v-6h3.37v1.09h-2.18v1.29z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m20.94 16.11a3.08 3.08 0 1 0 -3.08-3.11 3.07 3.07 0 0 0 3.08 3.11z",
    fill: "#f16822"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDiscover);
export default __webpack_public_path__ + "static/media/card-discover.9639e42e6b4fb44a1bb58d1b9995578d.svg";
export { ForwardRef as ReactComponent };